<div>
  <div class="border-b border-gray-200 pb-1">
    <div class="flex h-12 items-center space-x-[20px]">
      <div class="w-[175px]">
        <div class="text-sm font-semibold" style="color: #676e7a">PATIENT/EDC DATA</div>
      </div>
      @if ((loading$ | async) === true) {
        <div class="flex-grow justify-start">
          <div class="h-5 w-5">
            <div class="border-1 spinner m-auto h-5 w-5"></div>
          </div>
        </div>
      } @else {
        @if (statusItem$ | async; as statusItem) {
          <div
            class="flex-grow justify-start"
            [ngClass]="{
              'flex flex-row items-center space-x-[28px]': isReviewInvestigatorDataLinkOpen(),
            }"
          >
            <div
              class="w-max rounded border px-2 py-1 text-sm"
              [ngStyle]="{
                'background-color': statusItem.bgColor,
                'border-color': statusItem.borderColor,
                color: statusItem.color,
              }"
            >
              {{ statusItem.text }}
            </div>
            @if (isReviewInvestigatorDataLinkOpen()) {
              <span class="aux-link cursor-pointer" (click)="onReviewInvestigatorData()">
                Review Investigator Data
              </span>
            }
          </div>
        }
      }
      @if (edcUploadDetails$ | async; as details) {
        <div class="flex w-28 flex-col items-start text-sm">
          <div class="mb-1">Date Uploaded</div>
          <div>{{ dateFormatter(details.date_uploaded) }}</div>
        </div>
      }
      @if (edcUploadDetails$ | async; as details) {
        <div class="flex w-28 flex-col items-start text-sm">
          <span class="mb-1">Uploaded by</span>
          <div>
            <aux-first-name-show
              [text]="
                userFormatter(details.uploaded_by).length > 30
                  ? userFormatter(details.uploaded_by).substring(0, 30)
                  : userFormatter(details.uploaded_by)
              "
              [showHyphenIfEmpty]="true"
            />
          </div>
        </div>
      }
      <div class="w-[345px] justify-start">
        <span
          [ngClass]="{
            'cursor-not-allowed opacity-50': isWorkflowLocked() || monthStatus !== 'open',
            'cursor-pointer': !isWorkflowLocked() && monthStatus === 'open',
          }"
          class="btn--hyperlink"
          (click)="!isWorkflowLocked() && monthStatus === 'open' && openUploadEDCModal()"
          [auxTooltip]="getDisabledTooltip()"
        >
          Upload EDC Data
        </span>
      </div>
    </div>
  </div>

  <div class="flex h-12 items-center space-x-[20px] border-b border-gray-200">
    <div class="w-[175px] shrink-0">
      <div class="text-sm font-semibold" style="color: #676e7a">PROTOCOL</div>
    </div>
    <div class="flex-grow justify-start">
      <span class="text-sm italic text-aux-gray-dark-100">Are there any protocol amendments?</span>
    </div>
    <div class="w-56"></div>
    <div class="w-[345px] shrink-0 justify-start">
      <span class="btn--hyperlink cursor-pointer" (click)="onProtocolAmendments()">
        View Protocol
      </span>
    </div>
  </div>

  <div class="flex h-12 items-center space-x-[20px]">
    <div class="w-[175px] shrink-0">
      <div class="text-sm font-semibold" style="color: #676e7a">SITES</div>
    </div>
    <div class="flex-grow justify-start">
      <span class="text-sm italic text-aux-gray-dark-100">
        Have you reviewed CTAs, site activations, and site closeouts?
      </span>
    </div>
    <div class="w-56"></div>
    <div class="w-[345px] shrink-0 justify-start">
      <span class="btn--hyperlink cursor-pointer" (click)="onSites()">View Sites</span>
    </div>
  </div>
</div>
